// Mock data for Essential Gemstones website

export const products = [
  {
    id: 'cross-faith',
    name: 'Cross of Faith Lava Stone Bracelet',
    price: '$24.00',
    image: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/e4xhbiak5gqtkn6/169bc339a348442090f43887e3989cac/original/Lava_Christian_Cross_Silver.jpg',
    description: 'Handcrafted lava stone bracelet featuring a silver cross — a quiet symbol of faith you can carry with you every day.',
    buyUrl: 'https://buy.stripe.com/dRm4gse2veRk3RZd15gYU00'
  },
  {
    id: 'chakra',
    name: '7 Chakra Lava Stone Bracelet',
    price: '$28.00',
    image: 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/e4xhbiak5gqtkn6/70ec7e9cde304cbe90a6029669423444/original/7-Chakra-Healing-Beaded-Bracelet-Natural-Lava-Stone-Diffuser-Bracelet-Jewelry.jpg',
    description: 'Seven sacred stones aligned with the chakras, paired with porous lava beads ready to diffuse your favorite oils.',
    buyUrl: 'https://buy.stripe.com/fZufZa1fJcJcdsz9OTgYU02'
  }
];

export const chakraStones = [
  { stone: 'Red Jasper', chakra: 'Root Chakra', color: '#a8473d', desc: 'Feel grounded and stable with Red Jasper, anchoring your spirit to the Earth. It brings strength and fosters a sense of security.' },
  { stone: "Tiger's Eye", chakra: 'Sacral / Solar Plexus', color: '#b07a3a', desc: 'Ignite your inner fire with Tiger\u2019s Eye, boosting confidence, courage, and personal power to pursue your true desires.' },
  { stone: 'Stone Amplifier', chakra: 'Solar Plexus', color: '#d4a85a', desc: 'Our special resin bead radiates warmth, harmonizing and amplifying the healing energies of all surrounding crystals.' },
  { stone: 'Serpentine', chakra: 'Heart Chakra', color: '#5e7a4a', desc: 'Open your heart to healing and renewal. Serpentine connects you to nature\u2019s nurturing energy, fostering peace and compassion.' },
  { stone: 'Turquoise', chakra: 'Throat Chakra', color: '#3a8a96', desc: 'Speak your truth with clarity and calm. Turquoise empowers honest communication and brings a tranquil presence.' },
  { stone: 'Lapis Lazuli', chakra: 'Third Eye Chakra', color: '#2b4a8c', desc: 'Awaken your intuition and inner wisdom. Lapis Lazuli deepens clarity and insight, guiding you towards profound understanding.' },
  { stone: 'Amethyst', chakra: 'Crown Chakra', color: '#7a4f9c', desc: 'Connect to higher consciousness and spiritual protection. Amethyst brings peace, purifying your aura and elevating your connection.' }
];

export const stats = [
  { number: '100%', label: 'Handmade', sub: 'Every bracelet assembled by hand, one at a time, with full intention.' },
  { number: '100+', label: 'Happy Customers', sub: 'A growing community of wearers who carry a piece of the earth daily.' },
  { number: '5.0\u2605', label: 'Rating', sub: 'Consistently loved for quality, beauty, and meaningful craftsmanship.' },
  { number: '2', label: 'Unique Designs', sub: 'From minimalist earth tones to bold gemstone pairings \u2014 a bracelet for every spirit.' }
];

export const lavaMeanings = [
  {
    title: 'Strength & Grounding',
    icon: 'Mountain',
    desc: 'Lava stone is formed under immense pressure and heat deep within the earth. That origin story translates into a powerful grounding energy \u2014 helping you stay rooted, calm, and centered.'
  },
  {
    title: 'Transformation',
    icon: 'Flame',
    desc: 'Few symbols are more powerful than lava cooling into solid stone. It represents profound transformation \u2014 the ability to move through fire and emerge stronger, more defined, and beautifully new.'
  },
  {
    title: 'Connection to Nature',
    icon: 'Leaf',
    desc: 'Lava stone is one of the most natural materials you can wear. Porous, earthy, and deeply textured, it carries the memory of ancient forests and volcanic coastlines.'
  },
  {
    title: 'Protection & Courage',
    icon: 'Shield',
    desc: 'Throughout cultures and centuries, volcanic stone has been revered as a protective talisman. Many believe it absorbs negative energy and fortifies the spirit.'
  }
];

export const craftSteps = [
  {
    number: '01',
    title: 'Premium Natural Materials',
    desc: 'Every bracelet begins with genuine lava stone sourced for its texture, porosity, and energy. Paired stones \u2014 amethysts, turquoise and more \u2014 are hand-selected for quality and color harmony.'
  },
  {
    number: '02',
    title: 'Thoughtful Design',
    desc: 'Each design is developed with a specific intention \u2014 grounding, protection, clarity, love. Bead combinations, sizing, and accent choices are deliberate, not accidental.'
  },
  {
    number: '03',
    title: 'Handcrafted Assembly',
    desc: 'Each bracelet is made by hand using durable, stretch-resistant elastic and secure finishing techniques. The result is a piece that is beautiful and built to last.'
  }
];

export const faqs = [
  {
    q: 'How do I care for my lava stone bracelet?',
    a: 'Lava stone is naturally porous and durable, but a little care goes a long way. Avoid prolonged exposure to water or harsh chemicals. To clean, simply wipe with a soft, slightly damp cloth and let air dry. Store in the pouch provided to prevent scratching from other jewelry.'
  },
  {
    q: 'Can I add essential oils to my lava stone bracelet?',
    a: 'Absolutely \u2014 in fact, it\u2019s one of the most beloved features of lava stone. Because the stone is porous, it naturally absorbs and diffuses essential oils throughout the day. Simply place 1\u20132 drops of your chosen oil on the lava beads, allow a moment to absorb, and enjoy hours of subtle, natural aromatherapy.'
  },
  {
    q: 'How long does shipping take?',
    a: 'Standard orders are typically handcrafted and shipped within 2\u20133 business days. Domestic delivery takes an additional 3\u20135 business days. We offer tracked shipping on all orders so you always know exactly where your bracelet is on its journey to you.'
  },
  {
    q: 'Do you accept returns or exchanges?',
    a: 'We want you to love your bracelet. If something isn\u2019t right, reach out within 30 days of delivery and we\u2019ll do our best to make it right \u2014 whether that\u2019s an exchange, or a solution that works for you. Custom orders are final sale, but we\u2019re always here to talk through any concerns.'
  }
];

export const galleryImages = [
  'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/height:400/https://cdn.gamma.app/e4xhbiak5gqtkn6/387d1923497d418ba2f394eaa42fe17d/original/d08456c0-ead8-41da-8e65-b2cc763935e8.jpg',
  'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/height:400/https://cdn.gamma.app/e4xhbiak5gqtkn6/147b5b49684d4a42aa23fcd65c03198d/original/70d0daee-d92d-469b-8efb-b6cba87da969.jpg',
  'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/height:400/https://cdn.gamma.app/e4xhbiak5gqtkn6/29f372cabe39493d94b4e330d9aa6835/original/99e9cc1d-3c06-4647-a475-3184d5dfae86.jpg',
  'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/height:400/https://cdn.gamma.app/e4xhbiak5gqtkn6/742c8de3a3c5488fb7cd904aa892f1b2/original/3fd64ee4-cd43-4cac-920e-378cde876b3a.jpg'
];

export const heroImage = 'https://images.unsplash.com/photo-1509222923806-0ef1ff755ab6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHx2b2xjYW5pYyUyMHN0b25lfGVufDB8fHx8MTc4MTczMjgzNXww&ixlib=rb-4.1.0&q=85';

export const storyImage = 'https://imgproxy.gamma.app/resize/quality:80/resizing_type:fit/width:2000/https://cdn.gamma.app/e4xhbiak5gqtkn6/3380d4a8244a4e7393e45cd0b281d33a/original/7-Chakra-Healing-Beaded-Bracelet-Natural-Lava-Stone-Diffuser-Bracelet-Jewelry-1.jpg';

export const founderImage = 'https://images.unsplash.com/photo-1632670549453-7a3dfac254a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxiZWFkZWQlMjBicmFjZWxldHxlbnwwfHx8fDE3ODE3MzI4MzV8MA&ixlib=rb-4.1.0&q=85';

export const craftImage = 'https://images.unsplash.com/photo-1609619742069-f5e18afeef17?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxqZXdlbHJ5JTIwbWFraW5nfGVufDB8fHx8MTc4MTczMjgzNXww&ixlib=rb-4.1.0&q=85';
